import React from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import { TestExecutionListBannerView } from './TestExecutionListBanner.view';

interface TestExecutionListBannerProps {
  showBanner: boolean;
}

const BANNER_TITLE = 'Track bugs seamlessly with QAlity Plus';
const BANNER_ITEMS: Array<string> = [
  'Benefit from unlimited Test Case executions.',
  'Create new bugs directly from the test execution page to save time.',
  'Link existing bugs with test steps for clear communication and better visibility.',
  'Navigate between test executions within the Test Cycle.',
  'Assign team members to test execution and keep the work on track.',
  'Get insight into previously reported bugs and make your testing as efficient as possible.',
];

const PRIMARY_ACTION_TEXT = 'Try it free';
const SECONDARY_ACTION_TEXT = 'Learn more';

export const TestExecutionListBanner: React.FC<TestExecutionListBannerProps> =
  ({ showBanner }: TestExecutionListBannerProps) => {
    const urlService = StorageOfUniqueServices.get('URLService');

    const primaryActionLink = urlService.getQalityPlusMarketplaceUrl();
    const secondaryActionLink = urlService.getQalityVersionsComparisonUrl();

    return (
      <>
        {showBanner && (
          <TestExecutionListBannerView
            title={BANNER_TITLE}
            items={BANNER_ITEMS}
            primaryAction={{
              text: PRIMARY_ACTION_TEXT,
              link: primaryActionLink,
            }}
            secondaryAction={{
              text: SECONDARY_ACTION_TEXT,
              link: secondaryActionLink,
            }}
          />
        )}
      </>
    );
  };
